import apiAddress from "./apiAddress";

const apiLinkedPhoneNumbers = async ({ token }) => {
  const query = `{
        linkedPhoneNumbers {
          phoneNumber
          friendlyName
        }
      }`;

  try {
    const result = await fetch(apiAddress(), {
      method: "POST",
      withCredentials: true,
      credentials: "include",
      headers: {
        Authorization: `Bearer ${token}`
      },
      body: JSON.stringify({
        query
      })
    });
    const json = await result.json();
    return json.data.linkedPhoneNumbers;
  } catch (error) {
    throw error;
  }
};

export default apiLinkedPhoneNumbers;
